'use client';
function getClientRects(element) {
    return Array.from(element.getClientRects());
}

export { getClientRects };
